import PropTypes from 'prop-types'

import View from '../../../components/bantrab/view/simple'
import Detail from '../../../components/bantrab/webinars/detail'
import { getBaseViewInfo } from '../../../components/bantrab/view/functions'

import { getPage } from '../../../api/bantrab'

import { TRANSMISSIONS_DETAIL_QUERY as PAGE_QUERY } from '../../../api/bantrab/queries'

async function getServerSideProps (context) {
  const { id } = context.params

  const { head, navbar, footer } = await getBaseViewInfo()

  let page = await getPage(id, PAGE_QUERY)
  page = await page.json()

  const body = page

  return {
    props: {
      head,
      navbar,
      body,
      footer
    }
  }
}

const Home = ({ head, navbar, body, footer }) => {
  return <View
    {...{ head, navbar, footer }}>
    <Detail
      webinar={body} />
  </View>
}

Home.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.object,
  footer: PropTypes.object
}

export { getServerSideProps }
export default Home
